__webpack_require__.p = "/bingo/";